import { KyAxiosWrapper } from "./ky-axios-wrapper"

export class ApiServiceSingleton {
  private static _baseInstance: KyAxiosWrapper | null = null
  private static _instance: KyAxiosWrapper | null = null
  private static _config: ApiServiceConfig = {}

  /**
   * Configure the API service with custom settings
   * @param config Configuration for the API service
   */
  public static configure(config: ApiServiceConfig): void {
    this._config = config
    // Reset instances so they'll be recreated with new config
    this._baseInstance = null
    this._instance = null
  }

  /**
   * Get the base instance without authentication
   */
  public static baseInstance() {
    if (!this._baseInstance) {
      const kyInstance = createBaseKyInstance(this._config)
      this._baseInstance = new KyAxiosWrapper(kyInstance)
    }

    return this._baseInstance
  }

  /**
   * Get the authenticated instance
   */
  public static instance() {
    if (!this._instance) {
      this._instance = ApiServiceSingleton.createCustomInstance(this._config)
    }

    return this._instance
  }

  /**
   * Create a new instance with custom configuration
   * This doesn't affect the singleton instances
   */
  public static createCustomInstance(config: ApiServiceConfig) {
    const kyInstance = createAuthenticatedKyInstance(config)
    return new KyAxiosWrapper(kyInstance)
  }
}
